import React, {Component} from "react";
import Main from "../../components/smart/Main";
import PlansFocus from "../../components/smart/PlansFocus";
import MainMessage from "../../components/smart/MainMessage";
import Logo from './../Logo.png';

class HomePage extends Component {
   
    
    render() {
        
        return (
                <Main Title=" " Description=" ">
                    <PlansFocus pageStatus={this.props.pageStatus} />
                    <MainMessage>
                        <div className="Main_Message_Content">
                            <p>
                                Matrix Healthcare was developed for employers, to provide high quality benefits for employees and their families.
                                Our Dental and Vision plans were created with you in mind. 
                                We are firmly committed to providing the highest level of quality and service. In fact, our unique partnership approach and commitment to service are why many of our clients have been with us for the past decade.
                            </p>
                        </div>
                        <div className="Main_Message_Logo_Box">
                            
                            <img src={Logo} alt="Logo"></img>
                        </div>  
                    </MainMessage>
                </Main>         
        )
    }
}

export default HomePage;
